module.exports = __webpack_public_path__ + "img/VERS1.2edc7d6a.png";